<div class="modal-header">
  <h4 class="modal-title">{{'Notes' | translateOrgSpecific}}</h4>
</div>
<div class="textArea">
  <textarea class="form-control" rows="10" [(ngModel)]="notes"></textarea>
</div>

  <div class="caseDataAlign" *ngIf="casedata">
    <label>{{casedata.caseName}}, {{casedata.participantname}} {{casedata.age}} {{casedata.gender}}</label>
  </div>
  <div style="text-align: right;margin-right: 15px;">
    <button class="btn btn-sm btn-apportis-tertiary btn-cancel" type="submit" (click)="onCancel()">{{ 'Cancel' | translateOrgSpecific }}</button>
    <button style="width:100px;" class="btn btn-sm btn-apportis-tertiary " type="submit" (click)="saveNotes()"
      [disabled]="!notes">{{ 'Save' | translateOrgSpecific }}</button>
  </div>

